module.exports = __webpack_public_path__ + "img/25ne.fdfde53e.svg";